import * as yup from 'yup';
import { emailField, optionalText, TranslateFn } from '../../../library/validationRules';

/** Mirrors the API's own @Size on an invited user's name, which is shorter than a patient's. */
const NAME_MAX = 50;

export const createInviteAdminSchema = (translate: TranslateFn) => yup.object({
    // Deliberately without the allowAdminHandle flag the login form passes: that lets the
    // literal string "admin" through, which is a sign-in handle rather than a mailbox, and
    // an invitation that cannot be delivered is worse than useless.
    emailAddress: emailField(translate),
    // optionalText rather than requiredText: the field may be blank -- the invitee fills
    // in their own name -- but the form always supplies a string, so the inferred type
    // matches InviteAdminFormValues instead of widening to string | undefined.
    firstName: optionalText(translate, NAME_MAX),
    lastName: optionalText(translate, NAME_MAX),
});
